import React, { useState } from 'react';
import { FaLightbulb, FaHandHoldingHeart, FaHome, FaChevronRight, FaShieldAlt, FaHandshake, FaHeart, FaUsers, FaStar, FaPlay, FaTimes } from 'react-icons/fa';

import { Helmet } from 'react-helmet-async';
import VisionMissionComponent from './VisionMissionComponent';
import TitleBanner from './TitleBanner';

const AboutUs = () => {
    const [showVideo, setShowVideo] = useState(false);
    const features = [
        {
          title: "NDIS registered provider",
          description: "with platinum standard SDA homes",
          imageUrl: "/cert4.png"
        },
        {
          title: "Qualified and trained",
          description: "care team tailored to your needs",
          imageUrl: "/CERTIFIED CARE TEAM.png"
        },
        {
          title: "Close to all amenities",
          description: "and services for community inclusion",
          imageUrl: "/AMMENITIES.png"
        }
      ];
    
      const values = [
        { name: "COMPASSION", imageUrl: "/Icons/LGA-About-Compassion-Icon.svg" },
        { name: "ACCOUNTABILITY", imageUrl: "/Icons/LGA-About-Accountability-Icon.svg" },
        { name: "RESPECT", imageUrl: "/Icons/LGA-About-Respect-Icon.svg" },
        { name: "EMPOWERMENT", imageUrl: "/Icons/LGA-About-Empowerment-Icon.svg" }
      ];
    return (
        <div className="min-h-screen">
            <Helmet>
                <title>About Us | Livability Care</title>
            </Helmet>
            <TitleBanner image="/Website_Title_Images/About_Us.svg" title="About Us" subheading="Discover who we are at Livability Care Australia"/>
            
            <VisionMissionComponent />

            {/* Content Section */}
            <div className="max-w-4xl mx-auto p-8">
      {/* Features Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16">
        {features.map((feature, index) => (
          <div key={index} className="border-2 border-primary rounded-2xl p-8 text-center relative"
          style={{
            transform: `rotate(${index % 2 === 0 ? '2' : '-4'}deg)`
          }}>
            <div className="mb-6 rounded-full w-32 h-32 flex items-center justify-center mx-auto">
              <img
                  src={feature.imageUrl}
                  alt={feature.title}
                  className="w-28 h-28"
              />
            </div>
            <h3 className="font-bold text-primary mb-3 text-xl">{feature.title}</h3>
            <p className="text-lg text-primary">{feature.description}</p>
          </div>
        ))}
      </div>

      {/* Values Section */}
      <div className="text-center mb-16">
        <h2 className="inline-block bg-primary text-white px-16 py-4 rounded-full text-3xl font-bold">
          VALUES
        </h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
        {values.map((value, index) => (
          <div key={index} className="text-center">
            <div className="relative mb-6">
              <div className="w-32 h-32 mx-auto border-2 border-primary rounded-full flex items-center justify-center">
                <div className="relative w-24 h-24">
                  <div className="absolute inset-0 flex items-center justify-center">
                    
                    <img
                      src={value.imageUrl}
                      alt={value.name}
                      className="w-18 h-18 relative z-10"
                    />
                  </div>
                </div>
              </div>
            </div>
            <h3 className="text-primary font-bold text-xl">{value.name}</h3>
          </div>
        ))}
      </div>
    </div>

            

            

            

            {/* Video and Tagline Section */}
            <section className="py-24 mt-12 bg-[#336fb8]">
                <div className="container mx-auto px-4">
                    <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
                        {/* Video Area - Now on Left */}
                        <div className="relative group cursor-pointer animate-slideFromLeft" onClick={() => setShowVideo(true)}>
                            <div className="relative rounded-xl overflow-hidden">
                                <img 
                                    src="/maxresdefault_thumbnail.jpg" 
                                    alt="Care Video Thumbnail" 
                                    className="w-full h-[500px] object-cover transform transition-transform duration-500 group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-primary/30 transition-opacity duration-300 group-hover:bg-primary/20"/>
                                <div className="absolute inset-0 flex items-center justify-center">
                                    <div className="w-24 h-24 bg-primary-yellow rounded-full flex items-center justify-center transform transition-transform duration-300 group-hover:scale-110">
                                        <FaPlay className="text-primary text-3xl ml-2"/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Content */}
                        <div className="space-y-8 animate-slideFromRight">
                            <h2 className="text-6xl font-bold font-arial-rounded text-white leading-tight">
                                "Because Care Begins
                                <span className="text-white"> at Home"</span>
                            </h2>
                            <div className="w-32 h-1 bg-primary-yellow"/>
                            <p className="text-2xl text-white font-avenir leading-relaxed">
                            Livability Care Australia is your trusted Supported Independent Living (SIL) provider. Collaborating with a diverse network of Specialist Disability Accommodation (SDA) providers, we are committed to delivering accessible housing and personalised care to NDIS participants.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Video Popup */}
            {showVideo && (
                <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 animate-fadeIn">
                    <div className="relative w-full max-w-4xl">
                        <button 
                            onClick={() => setShowVideo(false)}
                            className="absolute -top-12 right-0 text-white hover:text-primary-yellow transition-colors duration-300"
                        >
                            <FaTimes className="text-3xl"/>
                        </button>
                        <div className="relative pt-[56.25%]">
                            <iframe
                                className="absolute inset-0 w-full h-full rounded-site"
                                src="https://www.youtube.com/embed/gWlDFJMMsFM"
                                title="Livability Care Video"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </div>
            )}

           
        </div>
    );
};

export default AboutUs;
